





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapState('numUsers', ['num_users']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class JoinCTA extends Vue {
  @Prop({ type: String, required: true }) readonly btnAxId!: string;
  @Prop({ type: String, default: 'Get started' }) readonly buttonText!: string;
  @Prop({ type: Boolean, required: false }) readonly isMathcounts!: boolean;
  @Prop(String) readonly href!: string | undefined;
  @Prop(Boolean) readonly inPaywall!: boolean | undefined;
  private isMobile!: MobileGetter;

  private get buttonHref(): string {
    return this.href || this.$router.resolve({ name: 'nux_welcome' }).href;
  }

  private handleButtonClick(event: any) {
    this.$emit('button-click');
    if (!this.inPaywall && !this.isMathcounts) {
      event.preventDefault();
      this.$router.push({ name: 'nux_welcome' });
    }
  }
}
